export class LoginModel {
    email: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/pages/login/login.modelview.ts